var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vgt-wrap__footer fs-15 clearfix" }, [
    !_vm.hideRowCount
      ? _c("div", { staticClass: "footer__row-count pull-right" }, [
          _c("span", { staticClass: "footer__row-count__label fs-15 mr-2" }, [
            _vm._v(_vm._s(_vm.localize.ROWS_PER_PAGE_TEXT)),
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentPerPage,
                  expression: "currentPerPage",
                },
              ],
              staticClass:
                "footer__row-count__select w-auto mw-none js-vgt-selectpicker",
              attrs: {
                autocomplete: "off",
                name: "perPageSelect",
                "data-style": "btn-outline-secondary btn-sm",
              },
              on: {
                change: [
                  function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.currentPerPage = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.perPageChanged,
                ],
              },
            },
            [
              _vm._l(_vm.rowsPerPageOptions, function (option, idx) {
                return _c(
                  "option",
                  {
                    key: "rows-dropdown-option-" + idx,
                    domProps: { value: option },
                  },
                  [_vm._v("\n\t\t\t\t" + _vm._s(option) + "\n\t\t\t")]
                )
              }),
              _vm._v(" "),
              _vm.paginateDropdownAllowAll
                ? _c("option", { domProps: { value: _vm.total } }, [
                    _vm._v(_vm._s(_vm.localize.ALL)),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "footer__navigation pull-left" },
      [
        _c(
          "a",
          {
            staticClass: "footer__navigation__page-btn btn btn-sm arrow",
            class: [_vm.prevIsPossible ? "ml-0" : "d-none"],
            attrs: { href: "javascript:void(0);", tabindex: "0" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.firstPage($event)
              },
            },
          },
          [
            _c("svg", { staticClass: "icon-svg" }, [
              _c("use", {
                attrs: { href: _vm.spritePath + "#angle-double-small-left" },
              }),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "footer__navigation__page-btn btn btn-sm arrow",
            class: [_vm.prevIsPossible ? "" : "d-none"],
            attrs: { href: "javascript:void(0);", tabindex: "0" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.previousPage($event)
              },
            },
          },
          [
            _c("svg", { staticClass: "icon-svg" }, [
              _c("use", {
                attrs: { href: _vm.spritePath + "#angle-small-left" },
              }),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm._l(_vm.pages, function (page, index) {
          return [
            page.breakView
              ? _c(
                  "a",
                  {
                    key: index,
                    staticClass:
                      "footer__navigation__page-btn btn btn-sm disabled",
                    class: {
                      "ml-0": index == 0 && !_vm.prevIsPossible,
                      "mr-0":
                        index == Object.keys(_vm.pages).length &&
                        !_vm.nextIsPossible,
                    },
                    attrs: { href: "javascript:void(0);", tabindex: "0" },
                  },
                  [_vm._v("\n\t\t\t\t\t" + _vm._s(page.content) + "\n\t\t\t\t")]
                )
              : page.current
              ? _c(
                  "a",
                  {
                    key: index,
                    staticClass:
                      "footer__navigation__page-btn btn btn-sm current",
                    class: {
                      "ml-0": index == 0 && !_vm.prevIsPossible,
                      "mr-0":
                        index == Object.keys(_vm.pages).length &&
                        !_vm.nextIsPossible,
                    },
                    attrs: { href: "javascript:void(0);", tabindex: "0" },
                  },
                  [_vm._v("\n\t\t\t\t\t" + _vm._s(page.content) + "\n\t\t\t\t")]
                )
              : page.disabled
              ? _c(
                  "a",
                  {
                    key: index,
                    staticClass:
                      "footer__navigation__page-btn btn btn-sm disabled",
                    class: {
                      "ml-0": index == 0 && !_vm.prevIsPossible,
                      "mr-0":
                        index == Object.keys(_vm.pages).length &&
                        !_vm.nextIsPossible,
                    },
                    attrs: { href: "javascript:void(0);", tabindex: "0" },
                  },
                  [_vm._v("\n\t\t\t\t\t" + _vm._s(page.content) + "\n\t\t\t\t")]
                )
              : _c(
                  "a",
                  {
                    key: index,
                    staticClass:
                      "footer__navigation__page-btn btn btn-sm clickme",
                    class: {
                      "ml-0": index == 0 && !_vm.prevIsPossible,
                      "mr-0":
                        index == Object.keys(_vm.pages).length &&
                        !_vm.nextIsPossible,
                    },
                    attrs: { href: "javascript:void(0);", tabindex: "0" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.changePage(page.index + 1)
                      },
                    },
                  },
                  [_vm._v("\n\t\t\t\t\t" + _vm._s(page.content) + "\n\t\t\t\t")]
                ),
          ]
        }),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "footer__navigation__page-btn btn btn-sm arrow",
            class: [_vm.nextIsPossible ? "" : "d-none"],
            attrs: { href: "javascript:void(0);", tabindex: "0" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.nextPage($event)
              },
            },
          },
          [
            _c("svg", { staticClass: "icon-svg" }, [
              _c("use", {
                attrs: { href: _vm.spritePath + "#angle-small-right" },
              }),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "footer__navigation__page-btn btn btn-sm arrow",
            class: [_vm.nextIsPossible ? "mr-0" : "d-none"],
            attrs: { href: "javascript:void(0);", tabindex: "0" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.lastPage($event)
              },
            },
          },
          [
            _c("svg", { staticClass: "icon-svg" }, [
              _c("use", {
                attrs: { href: _vm.spritePath + "#angle-double-small-right" },
              }),
            ]),
          ]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }